// assets/collapsible.js
// Use event delegation to handle clicks on .collapsible elements,
// ensuring functionality persists after AJAX reloads.

// Listen on the body for clicks anywhere in the document
// so that dynamically injected .collapsible elements are handled too.
document.body.addEventListener('click', function(event) {
  const target = event.target;
  // Only proceed if the clicked element has the 'collapsible' class
  if (!target.classList.contains('collapsible')) return;

  // Toggle an 'active' class on the clicked header (for styling)
  target.classList.toggle('active');

  // Find the next sibling element (the content panel)
  const content = target.nextElementSibling;
  if (!content || !content.classList.contains('content')) return;

  // Toggle a class 'is-open' on the content panel
  content.classList.toggle('is-open');

  // If you prefer inline styling instead of CSS classes, uncomment:
  // content.style.display = content.style.display === 'block' ? 'none' : 'block';
});
